import React from 'react';
import { Flower, ShieldCheck } from 'lucide-react';

//import components
import Button from './ui/Button';

const Services = () => {
  const services = [
    {
      title: 'Massage Therapy',
      image: '/static/images/massage.jpg',
      description: 'Browse our full menu of massage treatments and pricing',
      icon: Flower,
      path: '../massage-therapy'
    },
    {
      title: 'Book a Verified Therapist',
      image: '/static/images/pagesBg/massage.jpg',
      description: 'Get matched instantly with a verified therapist near you',
      icon: ShieldCheck,
      path: '../book-massage'
    }
  ];
 
  return (
    <section className="py-8 md:py-16 bg-secondary relative overflow-hidden">
      {/* Decorative background elements - hidden on mobile */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute w-48 md:w-64 h-48 md:h-64 rounded-full bg-primary-light -top-20 -left-20" />
        <div className="absolute w-72 md:w-96 h-72 md:h-96 rounded-full bg-accent-hard -bottom-40 -right-20" />
        <div className="absolute w-32 md:w-40 h-32 md:h-40 rounded-full bg-primary-dark top-20 right-20" />
      </div>

      <div className="max-w-6xl mx-auto px-4 relative">
        <h2 className="text-2xl md:text-3xl font-bold font-body text-accent-hard text-center mb-3 md:mb-4">
          Our Services
        </h2>
        <hr className="w-24 md:w-32 h-1 bg-dim-dark mx-auto mb-8 md:mb-12 md:hover:w-48 transition-all duration-300" />
        <p className="text-center text-dim-dark font-lato mb-8 md:mb-12 max-w-2xl mx-auto text-sm md:text-base px-4">
          Verified massage therapists, matched to you in real time &mdash; at home, in a hotel
          room, or at a partner spa, with every payment protected by escrow.
        </p>
       
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 md:px-0 px-5">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="relative group overflow-hidden rounded-lg shadow-md md:transform md:transition-all md:duration-300 md:hover:scale-105 md:hover:shadow-xl"
            >
              <img
                src={service.image}
                alt={service.title}
                className="w-full h-48 md:h-64 object-cover md:transition-transform md:duration-500 md:group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-black bg-opacity-50 md:bg-opacity-40 md:transition-all md:duration-300 md:group-hover:bg-opacity-60">
                <div className="absolute inset-0 flex flex-col items-center justify-center p-4 md:translate-y-4 md:transform md:transition-all md:duration-300 md:group-hover:translate-y-0">
                  <service.icon className="text-white w-6 h-6 md:w-8 md:h-8 mb-2 md:mb-3 md:opacity-0 md:transform md:-translate-y-4 md:transition-all md:duration-300 md:group-hover:opacity-100 md:group-hover:translate-y-0" />
                  <h3 className="text-white text-xl md:text-2xl font-extrabold mb-2 md:mb-4">{service.title}</h3>
                  <p className="text-white text-center text-sm md:text-base mb-3 md:mb-4 md:opacity-0 md:transform md:translate-y-4 md:transition-all md:duration-300 md:group-hover:opacity-100 md:group-hover:translate-y-0 px-4 md:px-6">
                    {service.description}
                  </p>
                  <Button  to={service.path} variant='' className="text-white text-sm md:text-base border border-white px-4 md:px-6 py-1.5 md:py-2 rounded-full md:transform md:transition-all md:duration-300 hover:bg-white hover:text-dim-dark md:opacity-0 md:translate-y-4 md:group-hover:opacity-100 md:group-hover:translate-y-0">
                    read more
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;